import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import usePagination from 'hooks/usePagination';
import { Loading } from 'components';
import { BOARD_FAQ_MODULE_NO } from 'data/constants';

import boardService from 'services/board/board-service';
import FaqView from './FaqView';

export function Faq(props) {
  const { langList } = useOutletContext();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [faqList, setFaqList] = useState([]);
  // 페이지네이션
  const [searchParams] = useSearchParams();
  const { paginationRequest, setPaginationRequest, paginationResult, setPaginationResult } = usePagination(navigate, searchParams);

  useEffect(() => {
    const fetchFaqs = async function () {
      let data = [];

      try {
        const response = await boardService.listContents(BOARD_FAQ_MODULE_NO, paginationRequest.pageNumber, paginationRequest.pageSize);

        if (response) {
          if (response.rows) {
            data = response.rows;
          }
          setPaginationResult(response);
        }
      } catch (e) {
        console.error(e);
      }

      setFaqList(data);
    };

    if (paginationRequest) {
      fetchFaqs();

      setLoading(false);
    }

    return () => setLoading(true);
  }, [paginationRequest]);

  return (
    <>
      {loading && <Loading />}
      <FaqView
        list={langList.faq}
        faqList={faqList}
        paginationRequest={paginationRequest}
        paginationResult={paginationResult}
        setPaginationRequest={setPaginationRequest}
      />
    </>
  );
}
